





















































































import { Component, Mixins, Ref } from 'vue-property-decorator'
import Product from '@bizCmp/Product.vue'

import Copy from '@globalUtils/copy'
import { transform } from '@bizUtils/product'

import {
  getProductsByTwoHours,
  getProductsByToday,
  getCategories
} from '@/api/SaleRank'

import MixinSearchTabImg from '@bizMixins/search-tab-mg'

@Component({
  components: {
    Product
  }
})
export default class SaleRank extends Mixins(MixinSearchTabImg) {
  @Ref('productsRef') readonly productsRef!: HTMLElement

  products: {}[] = []

  activeProduct = {}

  productCopyId = 'product-promote'

  activeSaleTabIndex = 0
  saleTab = [
    {
      name: '实时销量榜',
      desc: '近2个小时热销榜，新鲜出炉',
      timeType: 'twoHour'
    },
    {
      name: '今日销量榜',
      desc: '今日热销榜，看看大家都买啥',
      timeType: 'today'
    }
  ]

  filter = false
  activeFilterTabIndex = 0
  filterTab = [
    {
      name: '全部',
      catid: ''
    }
  ]

  filterAttrs = [
    {
      name: '聚划算',
      checked: false
    },
    {
      name: '淘抢购',
      checked: false
    },
    {
      name: '天猫',
      checked: false
    },
    {
      name: '官方旗舰店',
      checked: false
    },
    {
      name: '天猫国际',
      checked: false
    },
    {
      name: '天猫超市',
      checked: false
    },
    {
      name: '淘宝冠店',
      checked: false
    },
    {
      name: '金牌卖家',
      checked: false
    },
    {
      name: '企业店铺',
      checked: false
    },
    {
      name: '极有家',
      checked: false
    },
    {
      name: 'ifashion',
      checked: false
    },
    {
      name: '品牌直销',
      checked: false
    },
    {
      name: '新品',
      checked: false
    },
    {
      name: '文案素材',
      checked: false
    },
    {
      name: '视频',
      checked: false
    },
    {
      name: '历史新低',
      checked: false
    },
    {
      name: '偏远地区包邮',
      checked: false
    },
    {
      name: '高评分',
      checked: false
    }
  ]

  filterValues = [
    {
      start: '月销量≥',
      value: '',
      end: '笔'
    },
    {
      start: '佣金比例≥',
      value: '',
      end: '%'
    },
    {
      start: '佣金金额≥',
      value: ''
    },
    {
      start: '单品评分≥',
      value: ''
    },
    {
      start: '券面额≥',
      value: ''
    },
    {
      start: '折扣≤',
      value: ''
    },
    {
      start: '收藏≥',
      value: '',
      end: '万'
    }
  ]

  created() {
    // TODO: 下一版本做
    // this.getCategories()
    this.getProducts()
  }

  async getProducts() {
    let api!: Function
    if (this.activeSaleTabIndex === 0) {
      api = getProductsByTwoHours
    } else if (this.activeSaleTabIndex === 1) {
      api = getProductsByToday
    } else {
      console.error(
        'activeSaleTabIndex: ' + this.activeSaleTabIndex + ' 不存在'
      )
      return
    }

    this.products = []

    const data = await api(
      {
        primary_caid: this.filterTab[this.activeFilterTabIndex].catid
      },
      {
        loading: {
          mountDom: this.$refs.productsRef
        },
        config: {
          similar: true
        }
      }
    )

    this.products = transform(data)
  }

  async getCategories() {
    const data = await getCategories(
      {},
      {
        timer: {
          hide: true
        }
      }
    )
    this.filterTab = this.filterTab.concat(data)
  }

  afterInitBySearchTabImg() {
    this.searchTabImgActive = 1
  }

  changeSaleTab(index: number) {
    if (this.activeSaleTabIndex !== index) {
      this.activeSaleTabIndex = index
    }

    this.getProducts()
  }

  changeFilterTab(index: number) {
    this.activeFilterTabIndex = index
    this.getProducts()
  }

  toggleFilter() {
    this.filter = !this.filter
  }

  comfirmFilter() {}

  resetFilter() {
    if (this.activeFilterTabIndex !== 0) {
      this.activeFilterTabIndex = 0
    }

    this.filterAttrs.forEach(filterAttr => {
      if (filterAttr.checked) {
        filterAttr.checked = false
      }
    })

    this.filterValues.forEach(filterValue => {
      if (filterValue.value !== '') {
        filterValue.value = ''
      }
    })
  }

  copyGuide(e: Event, product: {}, selector: string | HTMLElement) {
    if (this.activeProduct !== product) {
      this.activeProduct = product
    }

    new Copy(selector, { e })
  }

  jumpPromoteRecordPage(product: {}) {
    const routeUrl = this.$router.resolve({
      name: 'PromoteRecord',
      query: {
        product_id: product['product_id'],
        activity_id: product['activity_id']
      }
    })

    window.open(routeUrl.href, '_blank')
  }
}
